import { z } from 'zod';
export const permissionKeys = [
    'admin.users.read',
    'admin.users.manage',
    'admin.roles.read',
    'admin.roles.manage',
    'admin.teams.read',
    'admin.teams.manage',
    'admin.api_docs.read',
    'portfolio.clients.read',
    'portfolio.clients.manage',
    'portfolio.projects.read',
    'portfolio.projects.manage',
    'portfolio.projects.create',
    'portfolio.projects.read_all',
    'capacity.read',
    'capacity.workforce.read',
    'capacity.exceptions.manage',
    'capacity.allocations.manage',
    'capacity.allocations.manage_all',
    'planning.read',
    'planning.manage',
    'budgets.read',
    'budgets.manage',
    'billing.read',
    'billing.manage',
    'billing.approve',
    'governance.read',
    'governance.manage',
    'governance.publish',
    'reports.read',
    'reports.manage',
    'reports.publish',
    'data.quality.read',
    'data.quality.manage',
    'settings.read',
    'settings.manage',
    'forecast.settings.manage',
    'financial.rates.read',
    'financial.rates.manage',
    'financial.project_rates.manage',
    'agent.read',
    'integrations.read',
    'integrations.manage',
    'integrations.sync',
    'product.analytics.read',
];
export const permissionKeySchema = z.enum(permissionKeys);
export const projectScopedPermissions = [
    'portfolio.projects.read',
    'portfolio.projects.manage',
    'capacity.read',
    'capacity.allocations.manage',
    'planning.read',
    'planning.manage',
    'budgets.read',
    'budgets.manage',
    'billing.read',
    'billing.manage',
    'billing.approve',
    'governance.read',
    'governance.manage',
    'governance.publish',
    'reports.read',
    'reports.manage',
    'reports.publish',
    'data.quality.read',
    'data.quality.manage',
    'financial.rates.read',
    'financial.project_rates.manage',
    'agent.read',
];
export const permissionCatalog = [
    { key: 'admin.users.read', group: 'users', level: 'read', scope: 'organization' },
    { key: 'admin.users.manage', group: 'users', level: 'manage', scope: 'organization' },
    { key: 'admin.roles.read', group: 'roles', level: 'read', scope: 'organization' },
    { key: 'admin.roles.manage', group: 'roles', level: 'manage', scope: 'organization' },
    { key: 'admin.teams.read', group: 'teams', level: 'read', scope: 'organization' },
    { key: 'admin.teams.manage', group: 'teams', level: 'manage', scope: 'organization' },
    { key: 'admin.api_docs.read', group: 'api_docs', level: 'read', scope: 'organization' },
    { key: 'portfolio.clients.read', group: 'clients', level: 'read', scope: 'organization' },
    { key: 'portfolio.clients.manage', group: 'clients', level: 'manage', scope: 'organization' },
    { key: 'portfolio.projects.read', group: 'projects', level: 'read', scope: 'project' },
    { key: 'portfolio.projects.manage', group: 'projects', level: 'manage', scope: 'project' },
    {
        key: 'portfolio.projects.create',
        group: 'projects',
        level: 'sensitive',
        scope: 'organization',
    },
    {
        key: 'portfolio.projects.read_all',
        group: 'projects',
        level: 'read',
        scope: 'organization',
    },
    { key: 'capacity.read', group: 'capacity', level: 'read', scope: 'project' },
    {
        key: 'capacity.workforce.read',
        group: 'capacity',
        level: 'read',
        scope: 'organization',
    },
    {
        key: 'capacity.exceptions.manage',
        group: 'capacity',
        level: 'sensitive',
        scope: 'organization',
    },
    {
        key: 'capacity.allocations.manage',
        group: 'capacity',
        level: 'manage',
        scope: 'project',
    },
    {
        key: 'capacity.allocations.manage_all',
        group: 'capacity',
        level: 'manage',
        scope: 'organization',
    },
    { key: 'planning.read', group: 'planning', level: 'read', scope: 'project' },
    { key: 'planning.manage', group: 'planning', level: 'manage', scope: 'project' },
    { key: 'budgets.read', group: 'budgets', level: 'read', scope: 'project' },
    { key: 'budgets.manage', group: 'budgets', level: 'manage', scope: 'project' },
    { key: 'billing.read', group: 'billing', level: 'read', scope: 'project' },
    { key: 'billing.manage', group: 'billing', level: 'manage', scope: 'project' },
    { key: 'billing.approve', group: 'billing', level: 'sensitive', scope: 'project' },
    { key: 'governance.read', group: 'governance', level: 'read', scope: 'project' },
    { key: 'governance.manage', group: 'governance', level: 'manage', scope: 'project' },
    {
        key: 'governance.publish',
        group: 'governance',
        level: 'sensitive',
        scope: 'project',
    },
    { key: 'reports.read', group: 'reports', level: 'read', scope: 'project' },
    { key: 'reports.manage', group: 'reports', level: 'manage', scope: 'project' },
    { key: 'reports.publish', group: 'reports', level: 'sensitive', scope: 'project' },
    { key: 'data.quality.read', group: 'data_quality', level: 'read', scope: 'project' },
    { key: 'data.quality.manage', group: 'data_quality', level: 'manage', scope: 'project' },
    { key: 'settings.read', group: 'settings', level: 'read', scope: 'organization' },
    { key: 'settings.manage', group: 'settings', level: 'manage', scope: 'organization' },
    {
        key: 'forecast.settings.manage',
        group: 'forecast',
        level: 'manage',
        scope: 'organization',
    },
    {
        key: 'financial.rates.read',
        group: 'financials',
        level: 'read',
        scope: 'project',
    },
    {
        key: 'financial.rates.manage',
        group: 'financials',
        level: 'sensitive',
        scope: 'organization',
    },
    { key: 'financial.project_rates.manage', group: 'financials', level: 'manage', scope: 'project' },
    { key: 'agent.read', group: 'agent', level: 'read', scope: 'project' },
    {
        key: 'integrations.read',
        group: 'integrations',
        level: 'read',
        scope: 'organization',
    },
    {
        key: 'integrations.manage',
        group: 'integrations',
        level: 'manage',
        scope: 'organization',
    },
    {
        key: 'integrations.sync',
        group: 'integrations',
        level: 'sensitive',
        scope: 'organization',
    },
    {
        key: 'product.analytics.read',
        group: 'analytics',
        level: 'read',
        scope: 'organization',
    },
];
//# sourceMappingURL=permissions.js.map